import classNames from 'classnames';
import { Children, ComponentProps, ReactElement, cloneElement } from 'react';

import mapElementsRecursive from '../../helpers/react/mapElementsRecursive';
import Card from '../Card/Card';
import Relative from '../Relative/Relative';

import styles from './CardStack.module.css';

type CardProps = ComponentProps<typeof Card>;

type CardOrListOfCards =
    | null
    | false
    | string
    | undefined
    | ReactElement<CardProps, 'Card'>
    | Array<CardOrListOfCards>;

type CardStackProps = {
    children: CardOrListOfCards;
    noDecoration?: boolean;
    fullHeight?: boolean;
};

const CardStack = ({
    children,
    fullHeight = false,
    noDecoration = false,
}: CardStackProps) => {
    const childrenArray = Children.toArray(children);

    return (
        <Relative
            className={classNames({
                [styles.fullHeight]: fullHeight,
            })}
        >
            {mapElementsRecursive(childrenArray, (child, index, total) =>
                cloneElement(child, {
                    isFirst: index === 0,
                    decorate: !noDecoration && index === 0,
                    isLast: index === total - 1,
                    ...child.props,
                })
            )}
        </Relative>
    );
};

export default CardStack;
